import { useState } from 'react';
import { Outlet } from 'react-router';
import { styled } from '@mui/material/styles';
import useCollapseDrawer from 'src/hooks/useCollapseDrawer';
import { APP_BAR_DESKTOP, APP_BAR_MOBILE } from 'src/theme/layoutConstants';
import Navbar from './general/Navbar';
import AdminSidebar from './admin/AdminSidebar';
import { DRAWER_WIDTH, COLLAPSE_WIDTH } from 'src/layouts/general/Navbar/index';

// ----------------------------------------------------------------------

const RootStyle = styled('div')({
  overflow: 'hidden',
  height: '100%',
});

const MainStyle = styled('div', {
  shouldForwardProp: (prop) => !['isCollapse'].includes(prop),
})(({ theme, isCollapse }) => ({
  height: `calc(100% - ${APP_BAR_MOBILE}px)`,
  paddingTop: '16px',
  paddingBottom: '16px',
  marginTop: APP_BAR_MOBILE,
  [theme.breakpoints.up('lg')]: {
    height: `calc(100% - ${APP_BAR_DESKTOP}px)`,
    marginTop: APP_BAR_DESKTOP,
    marginLeft: isCollapse ? COLLAPSE_WIDTH : DRAWER_WIDTH,
  },
}));

// ----------------------------------------------------------------------

export default function AdminLayout() {
  const { isCollapse } = useCollapseDrawer();
  const [open, setOpen] = useState(false);

  return (
    <RootStyle>
      <Navbar onOpenSidebar={() => setOpen(true)} />
      <AdminSidebar isOpenSidebar={open} onCloseSidebar={() => setOpen(false)} />
      <MainStyle isCollapse={isCollapse}>
        <Outlet />
      </MainStyle>
    </RootStyle>
  );
}
